import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { business } from "../content/site";
import { Reveal } from "./Reveal";
import { trackEvent } from "../lib/analytics";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";

export const CTASection = ({ title, text }) => {
  const c = useCopy("cta");
  const cm = useCopy("common");
  const lp = useLp();
  return (
    <section className="bg-obsidian text-paper" data-testid="cta-section">
      <div className="container-site section-gap">
        <Reveal>
          <div className="max-w-3xl">
            <p className="tech-label !text-terracotta mb-5">{c.label}</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-paper leading-tight">{title || c.title}</h2>
            <p className="mt-5 text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">{text || c.text}</p>
            <div className="mt-9 flex flex-wrap gap-4">
              <Link
                to={lp("/contacto/")}
                data-testid="cta-section-primary"
                onClick={() => trackEvent("cta_budget_click", { location: "cta_section" })}
                className="btn-primary"
              >
                {cm.tellCase} <ArrowRight size={16} aria-hidden="true" />
              </Link>
              <a href={business.whatsappUrl} target="_blank" rel="noopener noreferrer"
                 data-testid="cta-section-secondary"
                 onClick={() => trackEvent("whatsapp_click", { location: "cta_section" })}
                 className="btn-secondary !border-paper/30 !text-paper hover:!bg-paper hover:!text-ink">
                <MessageCircle size={16} aria-hidden="true" /> {cm.whatsapp}
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
